import { getGeoValue, getTermsValue } from 'shared/common/packages/JsonQuery';

interface IParameters {
  prevJsonQuery: TJsonQuery;
  nextJsonQuery: TJsonQuery;
}

export const isGeoChanged = ({ prevJsonQuery, nextJsonQuery }: IParameters) => {
  const prevRegionId = getTermsValue('region')(prevJsonQuery);
  const nextRegionId = getTermsValue('region')(nextJsonQuery);

  const geoValue = getGeoValue()(nextJsonQuery);

  const isRegionChanged = prevRegionId && nextRegionId && nextRegionId[0] !== prevRegionId[0];

  const hasGeo = geoValue?.length;

  return Boolean(isRegionChanged || hasGeo);
};
